import
  React
from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  Base,
  Image,
  Text,
  VContainerVH,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../constants';

import {
  PrimaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

const NotFoundUI = props => {

  return (

    <VFillContainerVH
      height='100%'
      width='100%'
      textAlign='center'>

      <Base
        margin='99px 98px 52px 99px'>

        <Image
          src={Icons.ConnectU}
          height='40px'
          width='164px'/>

      </Base>

      <Base
        margin='0 27px 16px 28px'>

        <Text
          fontSize='20px'
          fontWeight='500'
          color={CustomColors.Grey11}>

          {props.title}
        </Text>
      </Base>

      <Text
        fontSize='16px'
        color={CustomColors.Grey9}>

        {props.message}
      </Text>

      <VContainerVH
        padding={'0 28px'}
        margin={'auto 0 40px'}
        width={'100%'}
        boxSizing={'border-box'}>

        <PrimaryButton
          text={props.buttonText}
          onClick={() => window.location = props.buttonUrl}/>
      </VContainerVH>
    </VFillContainerVH>
  );
};

NotFoundUI.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string
};

NotFoundUI.defaultProps = {
  title: 'Something went wrong!',
  message: 'We can\'t find the page you\'re looking for.',
  buttonText: 'Back to home page',
  buttonUrl: '/home'
};

NotFoundUI.pageName = 'cbu: connectu: not found page';
NotFoundUI.tagViewData = {
  page_section: 'error pages',
  page_event: 'page_error',
  error_message: 'page not found'
};

export const NotFound = withScreenViewTagging(NotFoundUI);